<div class="item">
    <!-- Radio button mode for multi-option acknowledgements -->
    <div *ngIf="hasOptions" class="pb-2">
        <p class="mb-3" [innerHTML]="getSafeHtml(artifact.description)"></p>
        <mat-radio-group
            [value]="selectedOption"
            [disabled]="artifact.locked"
            (change)="onOptionSelected($event.value)">
            <mat-radio-button *ngFor="let option of options" [value]="option.value" class="d-block mb-2">
                {{ option.label }}
            </mat-radio-button>
        </mat-radio-group>
    </div>

    <!-- Standard checkbox mode -->
    <div *ngIf="!hasOptions" class="pb-2">
        <mat-checkbox
            (change)='AcknowledgeArtifactChecked()'
            [disabled]="artifact.locked"
            [(ngModel)]="artifact.sectionValid"
        ><span [innerHTML]="getSafeHtml(artifact.description)"></span></mat-checkbox>
    </div>
</div>